import { Spinner, Switch } from "@heroui/react";

export interface StockCellProps {
  isInStock: boolean;
  isLoading: boolean;
  onChange: (isInStock: boolean) => void;
}

export function StockCell({ isInStock, isLoading, onChange }: StockCellProps) {
  return (
    <div className="flex items-center">
      {isLoading ? (
        <Spinner size="sm" />
      ) : (
        <Switch
          aria-label="In stock"
          isSelected={isInStock}
          size="sm"
          onChange={onChange}
        >
          <Switch.Content>
            <Switch.Control>
              <Switch.Thumb />
            </Switch.Control>
          </Switch.Content>
        </Switch>
      )}
    </div>
  );
}
